import React, { useRef, useEffect } from 'react';

import ProfilePhoto from "../../../images/profile/oro-profile-photo.png";
import ProfilePhoto2 from "../../../images/profile/user2.jpeg";
import DefaultPhoto from "../../../images/profile/oro-profile-photo-default.png";

import "./styles.css";
import { handleLogout, toTitleCase, RelevantIcon } from '../../../components/oro-module/commonFunctions';
import moment from "moment";



import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const useOutsideAlerter = (ref, cur) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        cur.liftGlobalState({ name: "showProfile" }, false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}


const ProfileMenu = (props) => {

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props);

  let { showProfile } = props.parentState;
  let { profile } = props.parentProps.parentState;
  if (!profile) { profile = {}; }

  let { display_name, assigned_branch, session_date, roles, username } = profile;
  if (!roles) { roles = []; }
  let progress = 71;

  let stats = { oro: { photo: DefaultPhoto, awards: [{ id: 1, desc: "Weekly No 1" }, { id: 2, desc: "Monthly No 1" }, { id: 3, desc: "Top Depositor" }, { id: 4, desc: "First to goal" }, { id: 5, desc: "Monthly No 1" }, { id: 6, desc: "Overall Topper" },], progress: 28 }, auditor1: { photo: DefaultPhoto, awards: [{ id: 1, desc: "Weekly No 1" }, { id: 2, desc: "Monthly No 1" }], progress: 18 }, apex: { photo: DefaultPhoto, awards: [{ id: 4, desc: "First to goal" }, { id: 5, desc: "Monthly No 1" }], progress: 18 } }
  if (!stats[username]) {
    stats[username] = { photo: DefaultPhoto, awards: [], progress: 12 };
  }


  return (
    <div
    >
      {showProfile &&
        <div
          ref={wrapperRef}
          className="custom-popover"
          id="profile-menu">
          <div className="col-sm-12" style={{ padding: 2 }}>
            <div style={{ backgroundColor: "#E8F0FE", color: "gray", fontSize: 12, height: 20, textAlign: "center", borderRadius: 5 }}>
              Administered by <span style={{ fontWeight: "bold" }}>decisionmachines.in </span><span style={{ color: "#0070ff", fontWeight: "bold" }}>Learn more.</span>
            </div>
          </div>

          <div id="profile-photo-large">
            <CircularProgressbarWithChildren styles={buildStyles({
              rotation: 0.5
            })} value={stats[username]['progress']} >
              <img src={stats[username]['photo']} />
            </CircularProgressbarWithChildren>
          </div>

          <div className="col-sm-12" style={{ textAlign: "center" }}>
            <div id="full-name">{toTitleCase(display_name)}</div>
            <div id="userid">{username}</div>
            <div id="userid">Assigned Branch : {assigned_branch} </div>
            <div id="session_date">Login Date : {session_date ? moment(session_date).format('DD/MM/YYYY') : ''}</div>
            <div id="userid">Roles : {roles.map(role => role.role).join(", ")} </div>
          </div>

          <div className="row col-sm-12 award-area">
            {stats[username]['awards'].map(({ id, desc }, idx) =>
              <div className="col-sm-2 " key={idx}><RelevantIcon icon={`award${id}`} tooltip={desc} style={{ height: 35, verticalAlign: "middle" }} /></div>
            )}
          </div>


          <div className="col-sm-12" id="more-options">
            <div id="signout-button" onClick={() => handleLogout({ props })}>
              Log out
            </div>
          </div>
          <div className="col-sm-12" id="copyright-msg">
            © Decision Machines Private Limited 2022
            {/* © The Haryana State Co-Op Apex Bank Ltd 2022 */}

          </div>

        </div>
      }
    </div>

  );
}

export default ProfileMenu;